import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import scroll from 'vue-scrollto'

Vue.config.productionTip = false

Vue.use(scroll)

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
